var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignupStep4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Steeper/04 Your Info") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Steeper/04-Your-Info",
    stroke: "none",
    strokeWidth: 1,
    fill: "current",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(0.000000, 0.000000)",
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.8787,11.2308 L14.0017,11.2308 C14.6817,11.2308 15.2337,10.6788 15.2337,9.9998 C15.2337,9.3208 14.6817,8.7688 14.0017,8.7688 L4.8787,8.7688 C4.2007,8.7688 3.6477,9.3208 3.6477,9.9998 C3.6477,10.6788 4.2007,11.2308 4.8787,11.2308",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8787,15.4115 L14.0017,15.4115 C14.6817,15.4115 15.2337,14.8595 15.2337,14.1805 C15.2337,13.5005 14.6817,12.9485 14.0017,12.9485 L4.8787,12.9485 C4.2007,12.9485 3.6477,13.5005 3.6477,14.1805 C3.6477,14.8595 4.2007,15.4115 4.8787,15.4115",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6852,7.0511 C10.2992,7.0511 10.7982,6.4991 10.7982,5.8191 C10.7982,5.1401 10.2992,4.5881 9.6852,4.5881 L4.7592,4.5881 C4.1462,4.5881 3.6482,5.1401 3.6482,5.8191 C3.6482,6.4991 4.1462,7.0511 4.7592,7.0511 L9.6852,7.0511 Z",
    id: "Fill-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.977,9.951 L19.977,5.991 C19.977,5.51 19.64,5.18 19.64,5.18 C19.64,5.18 14.819,0.358 14.648,0.217 C14.477,0.077 14.008,0 14.008,0 L13.674,0 L12.675,0 L10.491,0 L3.728,0 C1.667,0 0,1.667 0,3.728 L0,9.126 C0,9.678 0.448,10.126 1,10.126 C1.552,10.126 1.999,9.678 1.999,9.126 L1.999,3.728 C1.999,2.771 2.771,1.999 3.728,1.999 L10.491,1.999 L12.675,1.999 L13.09,1.999 C13.33,1.999 13.354,2.245 13.354,2.245 L13.354,5.983 C13.354,6.62 14.015,6.645 14.015,6.645 L17.753,6.645 L17.88,6.68 C18.008,6.715 17.993,6.933 17.993,6.933 L17.993,10.025 L17.995,10.024 L17.995,16.272 C17.995,17.229 17.223,18.001 16.266,18.001 L3.732,18.001 C2.774,18.001 2.002,17.229 2.002,16.272 L2.002,13.053 C2.002,12.501 1.555,12.054 1.002,12.054 C0.451,12.054 0.003,12.501 0.003,13.053 L0.003,16.272 C0.003,18.333 1.67,20 3.732,20 L16.266,20 C18.327,20 19.994,18.333 19.994,16.272 L19.977,9.951 Z",
    id: "Fill-7"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupStep4);
export default __webpack_public_path__ + "static/media/signup-step-4.2d15f30f1e21ca304b135b1d6c721b06.svg";
export { ForwardRef as ReactComponent };